<style lang="scss" scoped>
@import "../../sass/variables.scss";

h2 {
  font-style: normal;
}

.point-box {
  width: 100%;
  height: auto;
  background-color: $primary;
}

.opacity-80 {
  opacity: 0.8;
}
.negative-top {
  margin-top: -50px;
}
</style>

<template>
  <div>
    <div class="bg-secondary pt-40 pt-md-80 pb-60 pb-md-7">
      <div class="container">
        <h2 class="font-weight-bold fs-40 mb-20">Thema's</h2>
        <p class="fs-20 text-primary mb-0">Met deze thema's staan we klaar voor een mooie toekomst voor onze stad.</p>
      </div>
    </div>
    <div class="container negative-top">
      <div class="row">
        <div v-for="item in list" class="col-12 d-lg-none mb-25 mb-last-0">
          <div class="point-box p-25">
            <div class="w-100 mb-32">
                <p class="text-blue point-text font-weight-medium font-italic fs-24" v-html="item.title.rendered"></p>
            </div>
            <p class="fs-16 mb-0 text-primary-light opacity-80" v-html="item.description"></p>
          </div>
        </div>
        <div class="col-6 d-none d-lg-flex flex-column mb-25">
          <div  v-for="item in leftListPart" class="point-box p-25 mb-25 mb-last-0">
            <div class="w-100 mb-32">
                <p class="text-blue point-text font-weight-medium font-italic fs-24" v-html="item.title.rendered"></p>
            </div>
            <p class="fs-16 mb-0 text-primary-light opacity-80" v-html="item.description"></p>
          </div>
        </div>
        <div  class="col-6 d-none d-lg-flex flex-column mb-25">
          <div v-for="item in rightListPart" class="point-box p-25 mb-25 mb-last-0">
            <div class="w-100 mb-32">
                <p class="text-blue point-text font-weight-medium font-italic fs-24" v-html="item.title.rendered"></p>
            </div>
            <p class="fs-16 mb-0 text-primary-light opacity-80" v-html="item.description"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["data"],

  data() {
    return {
      list: [],
      page: 2,
      perPage: 6,
      viewingPoint: {},
      showViewingPoint: false,
    };
  },
  created() {
    this.list = this.data;
  },

  methods: {
    getListItems() {
      axios
        .get("api/v1/programma?perPage=" + this.perPage + "&page=" + this.page)
        .then((response) => {
          let res = response.data.data.standpunt;
          console.log(res);
          this.list = this.list.concat(res);
          this.page++;
        })
        .catch((errors) => {
          window.filter.clearOnFetch = false;
          window.filter.serverErrors = window.handleErrors = errors;
        });
    },
  },

  computed: {
    leftListPart() {
      return this.list.filter((item, index) => index % 2 === 0);
    },
    rightListPart() {
      return this.list.filter((item, index) => index % 2 !== 0);
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/PointComponent.vue